// @ts-ignore
window.caveSetVideoInGroup = (groupIndex, vidIndex) => {
  const videoGroups = document.querySelectorAll('.cave-video-group');
  const videos = videoGroups[groupIndex].querySelectorAll('video');
  const buttons = document.querySelectorAll('.videoswitcher');

  buttons.forEach((button, index) => {
    button.classList.toggle('active', index === vidIndex);
  });

  videos.forEach((video, index) => {
    video.style.display = 'none';
    video.pause();
    if (index === vidIndex) {
      video.style.display = 'block';
    }
  });
};

function initCaveVideoGroups() {
  // Get all video groups on page
  const videoGroups = document.querySelectorAll('.cave-video-group');

  // Loop over all of them
  videoGroups.forEach((group, groupIndex) => {
    // Get the individual video elements
    const videosElements = group.querySelectorAll('.wp-block-video');

    // Create placeholder for buttons
    let buttonsString = '<div class="cave-video-group__button-wrapper">';

    videosElements.forEach((videosElement, index) => {
      // Create and object to store all the info
      const item = {
        video: videosElement.querySelector('video'),
        caption: videosElement.querySelector('figcaption'),
      };

      // Hide non first
      if (index !== 0) {
        item.video.style.display = 'none';
      }

      // Create a button for each item
      const isActiveButton = index === 0 ? 'active' : '';
      buttonsString += `<a class="wp-block-button__link has-blue-400-background-color has-background wp-element-button videoswitcher ${isActiveButton}" onclick="caveSetVideoInGroup(${groupIndex}, ${index})">${item.caption.innerText}</a>`;
    });

    // Add buttons to wrapper
    buttonsString += '</div>';
    group.innerHTML += buttonsString;
  });
}

export default initCaveVideoGroups;
